import axios from "axios";
import api from "../utils/api";
export const fetchMenuData = async (lan) => {
  let rcode = await localStorage.getItem("rcode");
  let tn = await localStorage.getItem("tn");
  let langs = await localStorage.getItem("defaultLang");
  if (
    rcode?.toUpperCase() == "JFHPDR" &&
    (langs == null || langs == undefined)
  ) {
    lan = "de";
    localStorage.setItem("defaultLang", lan);
  }
  // }
  else {
    localStorage.removeItem("defaultLang");
  }

  const config = {
    method: "get",
    url: `${api.menuUrl}` + rcode + "/menu?lang=" + lan,
    headers: {
      "Ocp-Apim-Subscription-Key": api.menuApiSubscriptionKey,
    },
  };

  try {
    let myDate = new Date();
    let currentDate = new Date(
      `01/01/2000 ${myDate.getHours()}:${myDate.getMinutes()} `
    );
    const data = await axios(config);
    let dataVal = [];
    let dataValShow = [];
    if (data.data.success) {
      localStorage.setItem("siteDown", "fasle");
      if (data.data.info.Only_payment) {
        return { menu: dataVal, showMenu: dataValShow, info: data.data.info };
      } else {
        data.data.menu.map((cur) => {
          dataValShow.push(cur);
          localStorage.setItem("resClosePopupStatus", "false");
          if (
            cur.work_timings[0].unforseen_closed !== true &&
            cur.work_timings[0].unforseen_closed !== "true"
          ) {
            if (
              (rcode == "JETPDR" && cur?.menu_name == "Mid Night") ||
              (rcode == "AQPDR" && cur?.menu_name == "Overnight A La Carte") ||
              (rcode == "DAMPDR" && cur?.menu_name == "Overnight A La Carte")
            ) {
              let openTime = cur.work_timings[0].open_time;
              let closeTime = cur.work_timings[0].close_time;
              if (
                new Date(`01/01/2000 ${openTime}`) >
                new Date(`01/01/2000 ${closeTime}`)
              ) {
                if (
                  (currentDate > new Date(`01/01/2000 ${openTime}`) ||
                    currentDate < new Date(`01/01/2000 ${closeTime}`)) &&
                  currentDate < new Date(`02/01/2000 ${closeTime}`)
                ) {
                  dataVal.push(cur);
                  localStorage.setItem("selectedMenu", cur.menu_name);
                } else {
                  return {
                    menu: dataVal,
                    showMenu: dataValShow,
                    info: data.data.info,
                  };
                }
              } else {
                if (
                  currentDate > new Date(`01/01/2000 ${openTime}`) &&
                  currentDate < new Date(`01/01/2000 ${closeTime}`)
                ) {
                  dataVal.push(cur);
                  localStorage.setItem("selectedMenu", cur.menu_name);
                } else {
                  return {
                    menu: dataVal,
                    showMenu: dataValShow,
                    info: data.data.info,
                  };
                }
              }
            } else {
              if (
                cur.work_timings[0].open_for_order === true ||
                cur.work_timings[0].open_for_order === "true"
              ) {
                dataVal.push(cur);
                localStorage.setItem("selectedMenu", cur.menu_name);
              } else {
                return {
                  menu: dataVal,
                  showMenu: dataValShow,
                  info: data.data.info,
                };
              }
            }
          } else {
            return {
              menu: dataVal,
              showMenu: dataValShow,
              info: data.data.info,
            };
          }
          return { menu: dataVal, showMenu: dataValShow, info: data.data.info };
        });
        if (dataVal.length === 0) {
          localStorage.setItem("selectedMenu", dataValShow[0].menu_name);
          return { menu: dataVal, showMenu: dataValShow, info: data.data.info };
        }
        return { menu: dataVal, showMenu: dataValShow, info: data.data.info };
      }
    } else {
      localStorage.setItem("siteDown", "true");
      return data;
    }
  } catch (error) {
    localStorage.setItem("siteDown", "true");
    return error.response.data;
  }
};
